export var iconNames = [
    'accommodation',
    'bankCard',
    'bed',
    'cafe',
    'calendar',
    'car',
    'check',
    'checkboxActive',
    'checkboxEmpty',
    'chevronLeft',
    'compare',
    'cross',
    'demography',
    'facebook',
    'favourite',
    'filter',
    'fitness',
    'forest',
    'gym',
    'hamburger',
    'help',
    'home',
    'info',
    'instagram',
    'jogging',
    'layers',
    'libra',
    'lifestyle',
    'linkedin',
    'lock',
    'menu',
    'notification',
    'phone',
    'pin',
    'play',
    'plus',
    'profile',
    'question',
    'quiet',
    'search',
    'todo',
    'todoList',
    'transport',
    'underground'
];
//# sourceMappingURL=types.js.map